import React from 'react';
import { Link } from 'react-router-dom';
import { FaSearch } from 'react-icons/fa';
import { ImCross } from 'react-icons/im';

const Search = () => {
	return (
		<>
			<div className=' bg-white h-[150px] z-20 overflow-hidden'>
				<Link to='/'>
					<div className=' absolute bg-red-400 right-4 top-0 w-10 h-10 p-0 m-0 rounded-b-lg flex justify-center items-center hover:bg-red-600'>
						<ImCross className=' text-white ' />
					</div>
				</Link>
				<form>
					<div className=' px-20 py-14'>
						<p className=' mb-2 text-sm opacity-80'>Start typing And Press Enter To Search</p>
						<div className=' flex border-red-400 border-2 justify-center items-center h-16 rounded-lg'>
							<input
								type='text'
								placeholder='Search entire store...'
								className=' w-full border-transparent outline-none pl-4 placeholder:text-red-500 '
							/>
							<div className=' bg-red-400 hover:bg-red-600 h-16 w-16 flex justify-center items-center rounded-e-lg'>
								<FaSearch className='   text-white ' />
							</div>
						</div>
					</div>
				</form>
			</div>
		</>
	);
};

export default Search;
